// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-to-pdf-modal {
  max-width: initial !important;
  display: flex;
  height: 100%;
  padding: 0 !important;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 0 !important;
  background: transparent !important;
}
@media print {
  .export-to-pdf-modal {
    height: auto;
    display: block;
  }
}
.export-to-pdf-modal-overlay {
  padding: 32px;
}
@supports (backdrop-filter: blur(5px)) {
  .export-to-pdf-modal-overlay {
    backdrop-filter: blur(5px);
    background: rgba(16, 24, 40, 0.8) !important;
  }
}
@supports not (backdrop-filter: blur(5px)) {
  .export-to-pdf-modal-overlay {
    background: rgb(16, 24, 40) !important;
  }
}
@media print {
  .export-to-pdf-modal-overlay {
    height: auto;
    overflow-y: visible;
  }
}
.export-to-pdf-modal .modal-header {
  padding-bottom: 12px;
  border-bottom: 1px solid #667085;
}
@media print {
  .export-to-pdf-modal .modal-header {
    display: none;
  }
}
.export-to-pdf-modal .modal-header .left {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: rgb(255, 255, 255);
}
.export-to-pdf-modal .modal-header .right {
  display: inline-flex;
  gap: 16px;
  align-items: center;
}
.export-to-pdf-modal .modal-header .right .assignment-action {
  width: 56px;
  height: 44px;
  display: inline-flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.export-to-pdf-modal .modal-header .right .close-btn i::before {
  color: #ffffff;
}
.export-to-pdf-modal .modal-body {
  width: 100%;
  overflow-y: auto;
  overscroll-behavior: none;
  background-color: #ffffff;
}
@media print {
  .export-to-pdf-modal .modal-body {
    overscroll-behavior: initial;
  }
  .export-to-pdf-modal .modal-body ::-webkit-scrollbar {
    display: none;
  }
}
.export-to-pdf-modal .modal-body .unit-page-layout {
  max-width: 100%;
  padding: 32px 32px 0;
}
@media print {
  .export-to-pdf-modal .modal-body .unit-page-layout {
    padding: 0;
    margin-top: 32px;
  }
}
.export-to-pdf-modal .modal-body .unit-page-layout .table-header {
  font-size: 16px;
  line-height: 24px;
}
.export-to-pdf-modal .modal-body .unit-page-layout .table-header b {
  font-weight: 700;
}
.export-to-pdf-modal .modal-body .unit-page-layout .table-container {
  max-height: 100%;
  margin-top: 12px;
  overflow-y: auto;
}
.export-to-pdf-modal .modal-body .unit-page-layout .table-container td {
  padding: 5px 24px;
}
@media print {
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container {
    position: initial;
    max-height: none;
    overflow: visible;
  }
}
@media print {
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table {
    height: 100%;
    max-height: none;
    overflow: visible;
  }
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table * {
    font-size: 12px !important;
  }
}
@media print {
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table thead th.cna {
    min-width: 100px;
  }
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table thead th.resident {
    min-width: 120px;
  }
}
@media print {
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table th,
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table td {
    padding: 5px;
  }
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table th.cna-column,
  .export-to-pdf-modal .modal-body .unit-page-layout .table-container table td.cna-column {
    width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/unit/components/export-to-pdf-modal/styles.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;EAEA,kCAAA;AAAF;AAEE;EAXF;IAYI,YAAA;IACA,cAAA;EACF;AACF;AACE;EACE,aAAA;AACJ;AACI;EAHF;IAII,0BAAA;IACA,4CAAA;EAEJ;AACF;AAAI;EARF;IASI,sCAAA;EAGJ;AACF;AADI;EAZF;IAaI,YAAA;IACA,mBAAA;EAIJ;AACF;AADE;EACE,oBAAA;EACA,gCAAA;AAGJ;AADI;EAJF;IAKI,aAAA;EAIJ;AACF;AAFI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAIN;AADI;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;AAGN;AADM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAGR;AAEU;EACE,cAAA;AAAZ;AAOE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AALJ;AAOI;EANF;IAOI,4BAAA;EAJJ;EAMI;IACE,aAAA;EAJN;AACF;AAOI;EACE,eAAA;EACA,oBAAA;AALN;AAOM;EAJF;IAKI,UAAA;IACA,gBAAA;EAJN;AACF;AAMM;EACE,eAAA;EACA,iBAAA;AAJR;AAMQ;EACE,gBAAA;AAJV;AAQM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AANR;AAQQ;EACE,iBAAA;AANV;AAQQ;EARF;IASI,iBAAA;IACA,gBAAA;IACA,iBAAA;EALR;AACF;AAQU;EADF;IAEI,YAAA;IACA,gBAAA;IACA,iBAAA;EALV;EAOU;IACE,0BAAA;EALZ;AACF;AAUc;EACE;IACE,gBAAA;EARhB;EAUc;IACE,gBAAA;EARhB;AACF;AAeY;EAFF;;IAGI,YAAA;EAXZ;EAaY;;IACE,YAAA;EAVd;AACF","sourcesContent":[".export-to-pdf-modal {\n  max-width: initial !important;\n  display: flex;\n  height: 100%;\n  padding: 0 !important;\n  flex-direction: column;\n  justify-content: flex-start;\n  border-radius: 0 !important;\n  //background: rgba(16, 24, 40, 0.7) !important;\n  background: transparent !important;\n\n  @media print {\n    height: auto;\n    display: block;\n  }\n\n  &-overlay {\n    padding: 32px;\n\n    @supports (backdrop-filter: blur(5px)) {\n      backdrop-filter: blur(5px);\n      background: rgba(16, 24, 40, 0.8) !important;\n    }\n\n    @supports not (backdrop-filter: blur(5px)) {\n      background: rgba(16, 24, 40, 1) !important;\n    }\n\n    @media print {\n      height: auto;\n      overflow-y: visible;\n    }\n  }\n\n  .modal-header {\n    padding-bottom: 12px;\n    border-bottom: 1px solid #667085;\n\n    @media print {\n      display: none;\n    }\n\n    .left {\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 24px;\n      color: rgba(255, 255, 255, 1);\n    }\n\n    .right {\n      display: inline-flex;\n      gap: 16px;\n      align-items: center;\n\n      .assignment-action {\n        width: 56px;\n        height: 44px;\n        display: inline-flex;\n        padding: 0;\n        align-items: center;\n        justify-content: center;\n        background-color: transparent;\n      }\n\n      .close-btn {\n        i {\n          &::before {\n            color: #ffffff;\n          }\n        }\n      }\n    }\n  }\n\n  .modal-body {\n    width: 100%;\n    overflow-y: auto;\n    overscroll-behavior: none;\n    background-color: #ffffff;\n\n    @media print {\n      overscroll-behavior: initial;\n\n      ::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    .unit-page-layout {\n      max-width: 100%;\n      padding: 32px 32px 0;\n\n      @media print {\n        padding: 0;\n        margin-top: 32px;\n      }\n\n      .table-header {\n        font-size: 16px;\n        line-height: 24px;\n\n        b {\n          font-weight: 700;\n        }\n      }\n\n      .table-container {\n        max-height: 100%;\n        margin-top: 12px;\n        overflow-y: auto;\n\n        td {\n          padding: 5px 24px;\n        }\n        @media print {\n          position: initial;\n          max-height: none;\n          overflow: visible;\n        }\n\n        table {\n          @media print {\n            height: 100%;\n            max-height: none;\n            overflow: visible;\n\n            * {\n              font-size: 12px !important;\n            }\n          }\n\n          thead {\n            th {\n              @media print {\n                &.cna {\n                  min-width: 100px;\n                }\n                &.resident {\n                  min-width: 120px;\n                }\n              }\n            }\n          }\n\n          th,\n          td {\n            @media print {\n              padding: 5px;\n\n              &.cna-column {\n                width: 120px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
